import Vue from 'vue';
import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui-bundle';
import 'jquery-match-height';
import dayjs from 'dayjs';

Vue.component('date-picker', {

    template: '<div id="datepicker"></div>',
    props: ['dateFormat', 'date', 'startDate'],

    mounted: function () {
        var prv;
        var cur;
        var self = this;
        var endDate;
        var monthsToShow = 1;
        if (window.innerWidth > 1200) {
            var monthsToShow = 2;
        }

        // enquire.register('screen and (min-width:1200px)', {
        //   match: function() {
        //     monthsToShow = 2;
        //   },
        //   unmatch : function() {
        //     var monthsToShow = 1;
        //   },
        // });
        this.initialiseFrenchRegion();
        this.initDatePicker(prv, cur, self, monthsToShow)
    },

    beforeDestroy: function () {
        $(this.$el).datepicker('hide').datepicker('destroy');
    },

    methods: {
        sendDate: function () {
            this.$emit(date)
        },

        initialiseFrenchRegion() {
            $.datepicker.regional['fr'] = {
                closeText: "Fermer",
                prevText: "Précédent",
                nextText: "Suivant",
                currentText: "Aujourd'hui",
                monthNames: ["janvier", "février", "mars", "avril", "mai", "juin",
                    "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
                monthNamesShort: ["janv.", "févr.", "mars", "avr.", "mai", "juin",
                    "juil.", "août", "sept.", "oct.", "nov.", "déc."],
                dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
                dayNamesShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
                dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
                weekHeader: "Sem.",
                dateFormat: "dd/mm/yy",
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: ""
            };
        },

        initDatePicker: function (prv, cur, self, monthsToShow) {

            if (window.preferredCulture == null || window.preferredCulture == '') {
                $.datepicker.setDefaults($.datepicker.regional['en']);
            } else {
                $.datepicker.setDefaults($.datepicker.regional[window.preferredCulture]);
            }

            var minDate = 0; // This is 0 instead of null to prevent dates in the past
            var maxDate = null;

            if (window.minimumRoomBookingDate != null) {
                var currentDate = new Date();
                currentDate.setHours(0);
                currentDate.setMinutes(0);
                currentDate.setSeconds(0);
                currentDate.setMilliseconds(0);

                var minDateObj = new dayjs.unix(window.minimumRoomBookingDate).toDate();
                
                // Only update the min date if it is in the future
                if (minDateObj > currentDate) {
                    minDate = minDateObj;
                    console.log('BookingRestriction: New minimum date set for RoomBooking', minDate);
                }
            }

            if (window.maximumRoomBookingDate != null) {
                maxDate = new dayjs.unix(window.maximumRoomBookingDate).toDate();
                self.endDate = maxDate;
                console.log('BookingRestriction: New max date set for RoomBooking', maxDate);
            }

            $(this.$el).datepicker({
                numberOfMonths: monthsToShow,
                stepMonths: 1,
                minDate: minDate,
                maxDate: maxDate,
                firstDay: 1,
                prevText: "Previous month",
                nextText: "Next month",
                dateFormat: this.dateFormat,
                defaultDate: new Date(),

                beforeShowDay: function (date) {
                    return [true, ((date.getTime() >= Math.min(prv, cur) && date.getTime() <= Math.max(prv, cur)) ? 'ui-individual-date' : '')];
                },

                onSelect: function (dateText, inst) {
                    var d1, d2, d3, d4;

                    var previousActiveDay = $('#datepicker .ui-state-active');

                    if (previousActiveDay.attr('aria-pressed') != false) {
                        previousActiveDay.attr('aria-pressed', false);
                    }


                    prv = cur;
                    cur = (new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay)).getTime();
                    d1 = $.datepicker.formatDate('DD d MM yy', new Date(cur), {});

                    if (prv == -1 || prv == cur) {
                        prv = cur;

                    } else {

                        if (isNaN(prv) == false && isNaN(cur) == false) {
                            d1 = $.datepicker.formatDate('DD d MM yy', new Date(Math.min(prv, cur)), {});
                            d2 = $.datepicker.formatDate('DD d MM yy', new Date(Math.max(prv, cur)), {});
                            d3 = $.datepicker.formatDate('yymmdd', new Date(Math.min(prv, cur)), {});
                            d4 = $.datepicker.formatDate('yymmdd', new Date(Math.max(prv, cur)), {});
                        }
                    }

                    $('#date__start-date').html(d1)
                    $('#date__end-date').html(d2)

                    APP.calendarAccessibility.createStatusMessage(d1, d2, 'diningreservation-booking__status-message', $('.room-booking__calendar'));

                    // update Dom
                    self.$emit('update-date', [d3, d4, d1]);


                    //Manaully set active class if date click is current date
                    //It matches the start date selected to the current day. If they are the same it applies the manual current date class.
                    //This gets around a bizarre bug in jquery ui where if you clicked through a few months then went back to todays date you either couldn't select todays date or it was already selected
                    // Ticket MAYB-1928
                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1; //January is 0!
                    var yyyy = today.getFullYear();
                    var month;

                    today = yyyy + '-' + mm + '-' + dd;
                    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    var now = new Date();
                    var month = months[now.getMonth()]; // getMonth method returns the month of the date (0-January :: 11-December)
                    today = dd + ' ' + month + ' ' + yyyy;

                    setTimeout(function () {
                        var original = $('.date__start-date').html();
                        var result = original.substr(original.indexOf(" ") + 1);

                        if (today === result) {
                            $('.ui-datepicker-today').addClass("ui-datepicker-manual-current-day");
                        }
                        else {
                            $('.ui-datepicker-manual-current-day').removeClass("ui-datepicker-manual-current-day");
                        }

                        APP.calendarAccessibility.initDateAttributes('datepicker');


                    }, 50);

                },

                onChangeMonthYear: function (year, month, inst) {
                    $("#BookingRoomTabContent .hasDatepicker").removeClass("datepicker-init");

                    self.checkCalendarBounds(year, month - 1, inst.dpDiv, self, monthsToShow); // Month is 0 based

                    setTimeout(event => {
                        if (!self.startDate) {
                            $("#BookingRoomTabContent .ui-datepicker-current-day").removeClass("ui-datepicker-current-day");
                        }

                        $("#BookingRoomTabContent .hasDatepicker").addClass("datepicker-init");
                    }, 150);

                    setTimeout(function () {
                        APP.calendarAccessibility.initDateAttributes('datepicker');
                        APP.calendarAccessibility.setTabIndexes('datepicker');
                    }, 10);
                },

            }),

            // Immediately check calendar bounds to show current message if needed if max date is already being shown
            setTimeout(function() {
                if (self.endDate != null) {
                    var start = new Date();
                    if (window.minimumRoomBookingDate) {
                        start = new dayjs.unix(window.minimumRoomBookingDate).toDate();
                    }
                    self.checkCalendarBounds(start.getFullYear(), start.getMonth(), $(self.$el), self, monthsToShow);
                }
            }, 250);
            
            $("#BookingRoomTabContent .ui-datepicker-current-day").removeClass("ui-datepicker-current-day");
            setTimeout(event => {
                $("#BookingRoomTabContent .hasDatepicker").addClass("datepicker-init");
            }, 150);

            APP.calendarAccessibility.initPresentationMode('datepicker');
            APP.calendarAccessibility.initDateAttributes('datepicker');
            APP.calendarAccessibility.initKeyboardNavigation('datepicker');
        },
        checkCalendarBounds: function(year, month, calenderDiv, self, monthsToShow) {
            // Check to see whether the new date on the calendar is far in the future, if so show warning message
            // Timeout is to allow month to have updated in time
            setTimeout(function () {
                var monthDelta = self.calculateMonthDifferenceBetweenDates(new Date(year, month, 1), self.endDate);
                var maxCalendarEnd = monthsToShow == 1 ? 0 : 1;

                if (monthDelta - maxCalendarEnd <= 0) {
                    self.showValidBookingPeriodMessage(calenderDiv);
                } else {
                    self.hideValidBookingPeriodMessage(calenderDiv);
                }
            }, 100);
        },
        showValidBookingPeriodMessage: function($elem) {
            if (window.maximumRoomBookingMessage != null) {
                var dateFormattedString = window.maximumRoomBookingMessage.replaceAll("{0}", new dayjs.unix(window.maximumRoomBookingDate).format('D MMMM YYYY'));
                $elem.find('.ui-datepicker-header').addClass('date-exceededFuture');
                $elem.find('.ui-datepicker-header').attr('data-validBookingPeriod', dateFormattedString);
                $("#room-booking__status-message").html(dateFormattedString);
            }
        },
        hideValidBookingPeriodMessage: function($elem) {
            $elem.find('.ui-datepicker-header').removeClass('date-exceededFuture');
            if ($("#room-booking__status-message").html() == window.maximumRoomBookingMessage) {
                $("#room-booking__status-message").html("");
            }
        },
        calculateMonthDifferenceBetweenDates: function(date1, date2) {
            const year1 = date1.getFullYear();
            const month1 = date1.getMonth();
            const year2 = date2.getFullYear();
            const month2 = date2.getMonth();

            return (year2 - year1) * 12 + (month2 - month1);
        }
    }
});